import { Chip } from "@mui/material";

import { Option } from "api/common/types/common.types";
import { withForm } from "components/Forms/AppForm";
import { defaultMailListValues } from "features/memberPortal/mail/components/MailList/MailList.schema";
import { niapColorFamily } from "utils/color";

import { DetailCardMode } from "../MailListDetails.types";

const DetailCardCategory = withForm({
  defaultValues: defaultMailListValues,
  props: {
    categoryLabel: "",
    mode: "view" as DetailCardMode,
    color: "",
    categoryOptions: [] as Option[],
  },
  render: ({ form, categoryLabel, mode, color, categoryOptions }) => {
    if (mode === "view") {
      return (
        <Chip
          label={categoryLabel}
          color={niapColorFamily(color)}
          sx={{
            textTransform: "uppercase",
            borderRadius: "17px",
            height: 35,
            px: 2,
            fontWeight: "bold",
          }}
        />
      );
    }

    return (
      <form.AppField name="category">
        {(field) => (
          <field.SelectField
            label="Category"
            options={categoryOptions}
            required
            onChange={(value) => {
              form.setFieldValue("category", Number(value));
            }}
          />
        )}
      </form.AppField>
    );
  },
});

export default DetailCardCategory;
